import React from 'react';
import RaisedButton from '@material-ui/core/Button';
import {white} from '../../themes/colors';
import './iconButton.scss';

const style = {
    borderRadius: '50%',
    color: white,
    padding: 0,
    minHeight: '45px',
    minWidth: '45px',
    height: '45px',
    lineHeight: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const RaisedIconButton = (props) => {
    const circleButtonProps = {...props};
    delete circleButtonProps.containerClass;
    circleButtonProps.style = Object.assign({}, style, circleButtonProps.style);
    circleButtonProps.className = `icon-button ${circleButtonProps.className || ''}`;
    return <div id={props.id} className={`relative ${props.containerClass || ''}`}>
        <RaisedButton {...circleButtonProps} />
    </div>;
};

export default RaisedIconButton;
